import { Box } from '@mui/material'
import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { MainNavigation } from './MainNavigation'
import NodeSelector from './NodeSelector'
import { ReactComponent as AirImpactLogoWithText } from '../assets/img/logo/airimpact-logo-white-with-text.svg'
import { ReactComponent as AirImpactLogo } from '../assets/img/logo/airimpact-logo-white.svg'

export function Sidebar() {
  const navigate = useNavigate()
  const location = useLocation()
  const isSidebarOpen = useMemo(() => !location.pathname.includes('project'), [location])

  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        width: isSidebarOpen ? '220px' : '48px',
        paddingTop: 1,
        paddingBottom: 1.5,
        backgroundColor: 'grey.900',
        flexGrow: 1,
        height: '100vh',
        position: 'fixed',
      }}
    >
      <Box
        sx={{
          marginBottom: 2.5,
          paddingY: isSidebarOpen ? 3 : 2.25,
          paddingX: isSidebarOpen ? 2.5 : 1,
          borderBottom: '1px solid',
          borderColor: 'grey.800',
        }}
      >
        {isSidebarOpen ? (
          <AirImpactLogoWithText style={{ cursor: 'pointer' }} onClick={() => navigate('')} />
        ) : (
          <AirImpactLogo style={{ cursor: 'pointer' }} onClick={() => navigate('')} />
        )}
      </Box>

      <Box sx={{ paddingX: isSidebarOpen ? 1.5 : 0 }}>
        <MainNavigation isSidebarOpen={isSidebarOpen} />
      </Box>

      <Box sx={{ marginTop: 'auto', marginBottom: 1.5 }}>
        <NodeSelector isSidebarOpen={isSidebarOpen} />
      </Box>
    </Box>
  )
}
